import * as React from 'react';
import { Icon } from 'telia-front-react';
import { formatToTwoDecimalPlacesRoundingUp } from '../../../util/PriceUtil';
import { getSinglePriceValue, priceNotAvailable } from './TvComparisonPriceUtil';
export const createViewerSlotsGroup = (viewerSlotsMap, commonProps) => ({
    title: `${commonProps.translate('tvcomparison.viewerslots.label')}`,
    slots: [
        {
            id: 'tvcomparison.viewerslots.included.row',
            icon: '#tv-viewslot',
            title: `${commonProps.translate('tvcomparison.viewerslots.label')}`,
            description: `${commonProps.translate('tvcomparison.viewerslots.description')}`,
            packetInfos: resolveViewerSlotsInfo(viewerSlotsMap, commonProps).reverse(),
        },
        {
            id: 'tvcomparison.viewerslots.add.row',
            title: `${commonProps.translate('tvcomparison.viewerslots.extra.label')}`,
            packetPrices: resolveViewerSlotsPrices(viewerSlotsMap, commonProps).reverse(),
        },
    ],
});
const resolveViewerSlotsInfo = (viewerSlotsMap, commonProps) => {
    return commonProps.packageNames.map((pkgName) => {
        const pkgInfo = viewerSlotsMap[pkgName];
        return (React.createElement(React.Fragment, { key: pkgName }, pkgInfo.slots || pkgInfo.slots === 0 ? `${pkgInfo.slots} ${commonProps.translate('tvcomparison.viewerslots.suffix')}` : React.createElement(Icon, { modifiers: "#minus" })));
    });
};
const resolveViewerSlotsPrices = (viewerSlotsMap, commonProps) => {
    return commonProps.packageNames.map((pkgName) => {
        const pkgInfo = viewerSlotsMap[pkgName];
        if (pkgInfo.slotPrice || pkgInfo.slotPrice === 0) {
            const formattedPrice = `${formatToTwoDecimalPlacesRoundingUp(pkgInfo.slotPrice)}`;
            if (formattedPrice) {
                return getSinglePriceValue(formattedPrice, commonProps);
            }
        }
        return priceNotAvailable(commonProps.translate);
    });
};
